<div class="label-preview" [class.selected]="selected" [class.debug]="debug" data-testid="label-preview">
  <!-- Natural-size inner div, scaled to fit container -->
  <div class="label-natural" [style.width.px]="naturalWidthPx" [style.height.px]="naturalHeightPx"
    [style.transform]="'scale(' + scale() + ')'" (pointerdown)="onCanvasPointerDown()">
    <!-- QR code / Barcode region -->
    @if (showCode) {
    <div class="preview-qr" [style]="qrStyle" [class.editable-element]="editable" [class.interactive]="editable"
      [class.active]="isSelected('code')" [class.hovered]="hoveredElement() === 'code'"
      (pointerenter)="setHovered('code')" (pointerleave)="setHovered(null)"
      (pointerdown)="onElementPointerDown($event, 'code')" data-testid="label-element-code">
      @if (codeType === 'barcode') {
      <svg viewBox="0 0 80 24" fill="currentColor" preserveAspectRatio="none">
        <rect x="2" y="1" width="1.5" height="18" />
        <rect x="5" y="1" width="1" height="18" />
        <rect x="8" y="1" width="2" height="18" />
        <rect x="12" y="1" width="1" height="18" />
        <rect x="15" y="1" width="1.5" height="18" />
        <rect x="18" y="1" width="2.5" height="18" />
        <rect x="22" y="1" width="1" height="18" />
        <rect x="25" y="1" width="1.5" height="18" />
        <rect x="28" y="1" width="2" height="18" />
        <rect x="32" y="1" width="1" height="18" />
        <rect x="35" y="1" width="1.5" height="18" />
        <rect x="38" y="1" width="2.5" height="18" />
        <rect x="42" y="1" width="1" height="18" />
        <rect x="45" y="1" width="2" height="18" />
        <rect x="49" y="1" width="1" height="18" />
        <rect x="52" y="1" width="1.5" height="18" />
        <rect x="55" y="1" width="2" height="18" />
        <rect x="59" y="1" width="1" height="18" />
        <rect x="62" y="1" width="1.5" height="18" />
        <rect x="65" y="1" width="2.5" height="18" />
        <rect x="69" y="1" width="1" height="18" />
        <rect x="72" y="1" width="1.5" height="18" />
        <rect x="75" y="1" width="2" height="18" />
        <text x="40" y="23" text-anchor="middle" font-size="3" font-family="monospace">A1B2C3D4</text>
      </svg>
      } @else {
      <svg viewBox="0 0 24 24" fill="currentColor">
        <rect x="1" y="1" width="10" height="10" rx="1" stroke="currentColor" stroke-width="1" fill="none" />
        <rect x="3" y="3" width="6" height="6" fill="currentColor" />
        <rect x="13" y="1" width="10" height="10" rx="1" stroke="currentColor" stroke-width="1" fill="none" />
        <rect x="15" y="3" width="6" height="6" fill="currentColor" />
        <rect x="1" y="13" width="10" height="10" rx="1" stroke="currentColor" stroke-width="1" fill="none" />
        <rect x="3" y="15" width="6" height="6" fill="currentColor" />
        <rect x="14" y="14" width="3" height="3" fill="currentColor" />
        <rect x="19" y="14" width="4" height="3" fill="currentColor" />
        <rect x="14" y="19" width="3" height="4" fill="currentColor" />
        <rect x="19" y="19" width="4" height="4" fill="currentColor" />
      </svg>
      }

      @if (editable && isSelected('code')) {
      @for (handle of getHandleList(); track handle) {
      <button class="resize-handle" type="button" [attr.data-handle]="handle"
        [attr.aria-label]="'Resize code ' + handle" (pointerdown)="onResizeHandlePointerDown($event, 'code', handle)">
      </button>
      }
      }
    </div>
    }

    <!-- Debug: usable area (blue) -->
    @if (debug && usableAreaStyle) {
    <div [style]="usableAreaStyle"></div>
    }

    @if (checkpointNameVisible) {
    <div class="preview-text" [style]="getTextStyle('checkpointName')" [class.editable-element]="editable"
      [class.interactive]="editable" [class.active]="isSelected('checkpointName')"
      [class.hovered]="hoveredElement() === 'checkpointName'" (pointerenter)="setHovered('checkpointName')"
      (pointerleave)="setHovered(null)" (pointerdown)="onElementPointerDown($event, 'checkpointName')"
      data-testid="label-element-checkpoint-name">
      <span class="preview-text-content">{{ getTextContentByField('checkpointName') }}</span>
      @if (editable && isSelected('checkpointName')) {
      @for (handle of getHandleList(); track handle) {
      <button class="resize-handle" type="button" [attr.data-handle]="handle"
        [attr.aria-label]="'Resize checkpoint name ' + handle"
        (pointerdown)="onResizeHandlePointerDown($event, 'checkpointName', handle)">
      </button>
      }
      }
    </div>
    }

    @if (formNameVisible) {
    <div class="preview-text" [style]="getTextStyle('formName')" [class.editable-element]="editable"
      [class.interactive]="editable" [class.active]="isSelected('formName')"
      [class.hovered]="hoveredElement() === 'formName'" (pointerenter)="setHovered('formName')"
      (pointerleave)="setHovered(null)" (pointerdown)="onElementPointerDown($event, 'formName')"
      data-testid="label-element-form-name">
      <span class="preview-text-content">{{ getTextContentByField('formName') }}</span>
      @if (editable && isSelected('formName')) {
      @for (handle of getHandleList(); track handle) {
      <button class="resize-handle" type="button" [attr.data-handle]="handle"
        [attr.aria-label]="'Resize form name ' + handle"
        (pointerdown)="onResizeHandlePointerDown($event, 'formName', handle)">
      </button>
      }
      }
    </div>
    }

    @if (serialNumberVisible) {
    <div class="preview-text" [style]="getTextStyle('serialNumber')" [class.editable-element]="editable"
      [class.interactive]="editable" [class.active]="isSelected('serialNumber')"
      [class.hovered]="hoveredElement() === 'serialNumber'" (pointerenter)="setHovered('serialNumber')"
      (pointerleave)="setHovered(null)" (pointerdown)="onElementPointerDown($event, 'serialNumber')"
      data-testid="label-element-serial-number">
      <span class="preview-text-content">{{ getTextContentByField('serialNumber') }}</span>
      @if (editable && isSelected('serialNumber')) {
      @for (handle of getHandleList(); track handle) {
      <button class="resize-handle" type="button" [attr.data-handle]="handle"
        [attr.aria-label]="'Resize serial number ' + handle"
        (pointerdown)="onResizeHandlePointerDown($event, 'serialNumber', handle)">
      </button>
      }
      }
    </div>
    }
  </div>
</div>